import {getPhoto} from "../../api/mainpage/photo";

const state = () => ({
  photo:[],
  newsId: null
})


const getters = {
  get_photo(state) {
    return state.photo;
  },
}

const mutations = {
  SET_PHOTO(state,data){
    state.photo = data;}
}

const actions = {
  async fetchPhoto({ commit }) {
    try {
      const response = await getPhoto();
      commit('SET_PHOTO', response.data.results);
    } catch (error) {
      // handle the error here
    }
  },

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
